import React from "react";
import styled from "@emotion/styled";
import { NavLink } from "react-router-dom";
import Shared04Logo from "../../guestsharedcomponents/Shared04Logo/Shared04Logo";
import Shared01Buttons from "../../guestsharedcomponents/Shared01Buttons/Shared01Buttons";
import Shared03Divider from "../../guestsharedcomponents/Shared03Divider/Shared03Divider";

// Navegación estática: no necesita memoización
const NAV_ITEMS = [
  { _id: "home", heading: "Home", link: "/" },
  { _id: "courses", heading: "Courses", link: "/courses" },
  { _id: "about", heading: "About Us", link: "/about-us" },
  { _id: "events", heading: "Events", link: "/events" },
  { _id: "pricing", heading: "Pricing", link: "/pricing" },
  { _id: "contact", heading: "Contact Us", link: "/contact-us" },
];

const ContainerHeader = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  background: rgb(0 0 0 / 80%);

  .main-logo {
    flex: 0 0 15rem;
    padding: 2.3rem 0;
  }

  .nav-link {
    display: none;
    color: rgba(255, 255, 255, 0.7);
    font-size: 1.35rem;
    padding: 3rem 2rem;
    text-decoration: none;

    .divider {
      opacity: 0;
      background: linear-gradient(90deg, transparent, #e6c28b, transparent);
    }
  }

  .nav-link:hover {
    color: #fff !important;

    .divider {
      opacity: 1;
      background: linear-gradient(90deg, transparent, #aeaeae, transparent);
      transition: all 0.4s ease;
    }
  }

  .is-active {
    color: #fff !important;
    font-weight: 700;

    .divider {
      opacity: 1;
      background: linear-gradient(90deg, transparent, #e6c28b, transparent);
      transition: all 0.4s ease;
    }
  }

  @media (min-width: 992px) {
    .nav-link {
      display: block;
    }
  }
`;

const G01MainHeader = () => {
  return (
    <ContainerHeader role="banner">
      <div className="t-container t-flex-op1">
        <Shared04Logo
          options={{
            logo: "https://res.cloudinary.com/djiqf3usa/image/upload/v1768425847/Clients/LTMastery/Frontpage/Images/Logos/t-mastery-sensual-bachata-online-academy-logo-new_iknc8f.webp",
            logo_link: "/",
            aria_label: "Logo LT Master",
            logo_alt: "LT Mastery Logo",
          }}
        />

        {/*  <nav aria-label="Navegación principal">
          <ul className="t-list-none t-flex-op1">
            {NAV_ITEMS.map((item) => (
              <li key={item._id}>
                <NavLink
                  to={item.link}
                  className={({ isActive }) =>
                    isActive ? "nav-link is-active" : "nav-link"
                  }
                >
                  <span>{item.heading}</span>
                  <Shared03Divider options={{}} />
                </NavLink>
              </li>
            ))}
          </ul>
        </nav> */}

        <Shared01Buttons
          options={{
            main_objinfo: {
              icon_left: false,
              icon_right: false,
              main_btn_heading: "Join Now",
              main_btn_link: "https://members.ltmastery.com/",
              main_btn_container_classes: "t-btn-principal-1",
              main_btn_classes: "t-uppercase t-font-1-2",
              main_btn_version: "external_link_button", //main_button, internal_link_button, external_link_button
              main_btn_loader: false,
              main_handleClick: false,
            },
            secundary_objinfo: false,
            btn_main_container_classes: "",
          }}
        />
      </div>
    </ContainerHeader>
  );
};

export default G01MainHeader;
